import { createFileRoute } from "@tanstack/react-router";
import { redirectIfModuleDisabled } from "@/lib/module-guards";

export const Route = createFileRoute("/_docs/docs/api-reference/$")({
	beforeLoad: () => redirectIfModuleDisabled("public_api", "/"),
});
